import { Home, Layers, User } from 'lucide-react'
import { useAnySheetOpen } from '../widgets'
import { FloatingBottomNav } from '../floating-bottom-nav.jsx'

// Global app-shell tabs. Neutral accent — identity comes from the (neutral) capsule.
const ITEMS = [
  { id: 'dashboard', label: 'Start',    icon: <Home size={25} /> },
  { id: 'bereiche',  label: 'Bereiche', icon: <Layers size={25} /> },
  { id: 'profil',    label: 'Profil',   icon: <User size={25} /> },
]

export function GlobalBottomNav({ active, onChange, dark }) {
  const sheetOpen = useAnySheetOpen()
  if (sheetOpen) return null

  return (
    <FloatingBottomNav
      items={ITEMS}
      activeId={active}
      onSelect={onChange}
      accent="var(--label-primary)"
      dark={dark}
      showLabels={false}
    />
  )
}
